<template>
<div style="background: #F6F6F6;padding-bottom: 30px;">
	<projectHead></projectHead>
	<div class="wrap">
		<div class="header">
			<div style="display: flex;align-items: center;"><img src="../../assets/images/indexIcon.png" alt="">
			<p><span>首页-项目需求池</span>-{{title}}</p></div>
			<div class="backof" @click="$router.go(-1)">返回</div>
		</div>
		<!-- <keep-alive > -->
			 
			    
					<router-view></router-view>
			    
			 <!-- <router-view v-if="!$route.meta.keepAlive"></router-view> -->
		<!-- </keep-alive> -->
		<!-- <router-view v-if="!$route.meta.keepAlive"></router-view> -->
		
		
	</div>
</div>
</template>

<script>
import projectHead from '../../components/projectHead'
export default{
	name:'projectNeed',
	components:{
		 projectHead,
	},
	data(){
		return{
			title:'',
			whereForm:"",
		}
	},
	created() {
		this.title = this.$route.meta.title
		console.log('created');
	},
	mounted() {
		console.log('mounted');
	},
	destroyed() {
		console.log('destroyed');
	},
	beforeRouteEnter(to, from, next){
		next(vm=>{
			if(to.meta.keepAlive){
				vm.$store.commit( "ADD_CachePage", "projectNeed")
			}
		})
	},
	beforeRouteUpdate(to,from,next) {
		if(to.meta.keepAlive){
			this.$store.commit( "ADD_CachePage", "projectNeed")
		}
		next() 
	},
	beforeRouteLeave(to, from, next){
		if(!to.meta.editor){
			this.$store.commit('Del_CachePage')
		}
		next()
	},

}
</script>

<style scoped lang="less">
	.header {
		.backof{
			text-align: center;
			line-height: 30px;
			cursor: pointer;
			width: 80px;
			height: 30px;
			background: #FFFFFF;
			border: 1px solid #D2D2D2;
		}
		display: flex;
		padding: 15px 0;
		align-items: center;
		justify-content: space-between;
		&>div{
			&>img {
				width: 16px;
				height: 16px;
			}
			
			&>p {
				font-size: 16px;
				margin-left: 10px;
			
				&>span {
					color: #888888;
				}
			}
		}
	}
</style>